import { EmptyState, Page } from '../components/ui'

export function PlaceholderPage({ title, icon }: { title: string; icon: string }) {
  return (
    <Page>
      <EmptyState icon={icon} title={title} description="Questa sezione è in fase di sviluppo." />
    </Page>
  )
}
